// HeaderIconButton.js - A single 36x36 icon button used in the header's
// right cluster (alerts bell, help "?", etc).

import React from "react";
import { Pressable, View } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { HEADER } from "./headerTheme";

export default function HeaderIconButton({
  icon,
  label,
  onPress,
  dot,
  active,
  testID,
  accessibilityState,
}) {
  return (
    <Pressable
      onPress={onPress}
      testID={testID}
      accessibilityLabel={label}
      accessibilityRole="button"
      accessibilityState={accessibilityState}
      title={label}
      style={({ hovered }) => [
        styles.button,
        (hovered || active) && styles.buttonActive,
      ]}
    >
      <MaterialCommunityIcons name={icon} size={22} color={HEADER.onBrand} />
      {dot ? <View style={styles.dot} testID={testID ? `${testID}-dot` : undefined} /> : null}
    </Pressable>
  );
}

const styles = {
  button: {
    width: 36,
    height: 36,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  buttonActive: {
    backgroundColor: HEADER.onBrandHover,
  },
  dot: {
    position: "absolute",
    top: 7,
    right: 7,
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: HEADER.amber,
    borderWidth: 2,
    borderColor: HEADER.brand,
  },
};
